(() => {
  'use strict';

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const engine = window.CorkopiaSmartBuildEngine;
  const cartSummary = window.CorkopiaCartSummary;
  const smartAdvisor = window.CorkopiaSmartBoxAdvisor;
  const orchestratorApi = window.CorkopiaEcosystemOrchestrator;
  const boxes = JSON.parse($('#CorkBoxDefinitions')?.textContent || '[]').filter((box) => box.active !== false).sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder));
  const settings = JSON.parse($('#CorkBoxSettings')?.textContent || '{}');
  const packingConfig = JSON.parse($('#CorkInventoryEngineConfig')?.textContent || '{}');
  const review = $('#SmartBuildReview');
  const exception = $('#SmartBuildException');
  let cart = { items: [], attributes: {} };
  let currentPlan = engine.plan(boxes, []);
  let inlineMessage = '';
  let inlineMessageTimer = null;
  let pendingPiece = null;
  let pendingOrchestrationElement = null;
  let manualBoxPreference = null;
  let checkoutStarted = false;
  let reviewOpener = null;
  let exceptionOpener = null;
  let renderedPieceCount = -1;
  let renderedSubtotal = -1;
  let advisorState = smartAdvisor?.readState?.(window.localStorage) || null;
  let advisorResponse = null;
  let advisorFingerprint = '';
  let advisorRenderTimer = null;
  let habitatPlan = null;
  const removedStack = [];

  const number = (value, fallback = 0) => Number.isFinite(Number(value)) ? Number(value) : fallback;
  const money = (cents = 0) => new Intl.NumberFormat(undefined, { style: 'currency', currency: settings.currency || 'USD' }).format(number(cents) / 100);
  const shippingMoney = (cents) => Number.isFinite(Number(cents)) ? money(cents) : 'Calculated at checkout';
  const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[character]);
  const truthy = (value) => value === true || value === 'true' || value === '1' || value === 1;
  const dimensionIn = (value, unit = 'in') => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return null;
    const normalized = String(unit || 'in').toLowerCase();
    return normalized === 'mm' ? parsed / 25.4 : normalized === 'cm' ? parsed / 2.54 : normalized === 'm' ? parsed * 39.3700787 : normalized === 'ft' ? parsed * 12 : parsed;
  };
  const weightOz = (value, unit = 'lb') => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return null;
    return unit === 'kg' ? parsed * 35.2739619 : unit === 'g' ? parsed * 0.0352739619 : unit === 'oz' ? parsed : parsed * 16;
  };
  const volumeCuIn = (value, unit = 'cu_in') => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) return null;
    const factors = { cu_in: 1, in3: 1, ml: 0.0610237, cl: 0.610237, l: 61.0237, m3: 61023.7441, us_fl_oz: 1.80469, us_pt: 28.875, us_qt: 57.75, us_gal: 231 };
    return parsed * (factors[String(unit || 'cu_in').toLowerCase()] || 1);
  };
  const normalizeShape = (value = '') => String(value || 'irregular').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  const packingFactor = (shape, override) => {
    const custom = Number(override);
    if (custom > 0) return custom;
    const configured = Number(packingConfig.shapeFactors?.[normalizeShape(shape)]);
    return configured > 0 ? configured : number(packingConfig.defaultPackingFactor, 0.65);
  };
  const boxByHandle = (handle) => boxes.find((box) => box.handle === handle || String(box.id) === String(handle));
  const emit = (action, details = {}) => {
    const payload = { event: 'corkopia_smart_build', smart_build_action: action, piece_count: pieceItems().length, ...details };
    document.dispatchEvent(new CustomEvent('corkopia:smart-build', { detail: payload }));
  };
  const analytics = (name, detail = {}) => window.CorkopiaAnalytics?.emit?.(name, detail, document);
  const toast = (message) => {
    const element = $('[data-build-toast]');
    if (!element) return;
    element.textContent = message;
    element.classList.add('is-visible');
    clearTimeout(toast.timer);
    toast.timer = setTimeout(() => element.classList.remove('is-visible'), 4400);
  };
  const readHabitatPlan = () => {
    try {
      const handoff = JSON.parse(sessionStorage.getItem('corkopia-habitat-smart-box-handoff-v1') || 'null');
      const expiresAt = Date.parse(handoff?.expiresAt);
      if (
        handoff?.version !== 'habitat-smart-box-handoff-v1'
        || handoff?.source !== 'habitat_intelligence'
        || handoff?.cartMutation !== null
        || handoff?.cartAuthority !== 'shopify'
        || handoff?.inventoryRevalidated !== true
        || !Number.isFinite(expiresAt)
        || expiresAt <= Date.now()
      ) return null;
      return handoff;
    } catch (_) {
      return null;
    }
  };
  const renderHabitatPlan = () => {
    const region = $('[data-habitat-box-plan]');
    if (!region) return;
    habitatPlan = habitatPlan || readHabitatPlan();
    const pieces = habitatPlan?.buildDna?.pieces || [];
    region.hidden = !pieces.length;
    if (!pieces.length) return;
    $('[data-habitat-box-plan-summary]').textContent =
      `${pieces.length} measured exact ${pieces.length === 1 ? 'piece is' : 'pieces are'} prepared. Fit was checked before this handoff.`;
    $('[data-habitat-box-plan-pieces]').innerHTML = pieces.map((piece) => `
      <li>
        ${piece.image ? `<img src="${escapeHtml(piece.image)}" alt="">` : '<span aria-hidden="true"></span>'}
        <div>
          <strong>${escapeHtml(piece.title || piece.piece_id || 'Exact cork piece')}</strong>
          <small>${escapeHtml(piece.piece_id || piece.variant_id)} · ${escapeHtml(String(piece.fit?.status || 'UNKNOWN').replace(/_/g, ' '))}</small>
        </div>
        ${piece.handle ? `<a href="/products/${encodeURIComponent(piece.handle)}">Review piece</a>` : ''}
      </li>
    `).join('');
  };
  const syncOverlayLock = () => {
    document.documentElement.classList.toggle('is-overlay-open', Boolean(document.querySelector('dialog[open]')));
  };
  const showInlineMessage = (message, duration = 6000) => {
    inlineMessage = message;
    clearTimeout(inlineMessageTimer);
    render();
    inlineMessageTimer = setTimeout(() => { inlineMessage = ''; render(); }, duration);
  };
  const pieceItems = () => cart.items.filter((item) => item.properties?._corkopia_inventory_type === 'individual_piece');
  const pieceSubtotal = () => pieceItems().reduce((sum, item) => sum + number(item.final_line_price), 0);
  const pieceWeightOz = () => pieceItems().reduce((sum, item) => sum + number(item.properties?._corkopia_piece_weight_oz), 0);
  const displayWeight = (ounces) => {
    const pounds = number(ounces) / 16;
    return `${pounds < 10 ? pounds.toFixed(2).replace(/0+$/, '').replace(/\.$/, '') : pounds.toFixed(1)} lb`;
  };
  const itemModel = (item) => {
    const properties = item.properties || {};
    const minimumBox = boxByHandle(properties._corkopia_minimum_box);
    return {
      variantId: item.variant_id,
      key: item.key,
      pieceId: properties._corkopia_piece_id,
      title: item.product_title,
      family: properties._corkopia_family || 'Natural cork',
      role: properties._corkopia_role || '',
      dimensionsText: properties._corkopia_dimensions || '',
      dimensions: [
        number(properties._corkopia_max_length_in, NaN),
        number(properties._corkopia_max_width_in, NaN),
        number(properties._corkopia_max_height_in, NaN)
      ],
      weightOz: number(properties._corkopia_piece_weight_oz),
      volumeCuIn: number(properties._corkopia_packing_volume_cu_in),
      minimumSort: number(minimumBox?.sortOrder),
      orientation: properties._corkopia_orientation || '',
      clearanceIn: number(properties._corkopia_protective_clearance_in),
      separateShipment: truthy(properties._corkopia_separate_shipment),
      manualReview: truthy(properties._corkopia_manual_review),
      image: item.image || '',
      priceCents: number(item.final_line_price),
      url: item.url || ''
    };
  };
  const readBuildContext = () => {
    try {
      const stored = JSON.parse(localStorage.getItem('corkopia-build-studio-v1') || '{}');
      return {
        project: String(stored.project || ''),
        enclosure: {
          width: number(stored.enclosure?.width, null),
          depth: number(stored.enclosure?.depth, null),
          height: number(stored.enclosure?.height, null)
        },
        style: String(stored.style || ''),
        preference: String(stored.preference || ''),
        budget: String(stored.budget || ''),
        decisions: Array.isArray(stored.decisions) ? stored.decisions : [],
        order: Array.isArray(stored.order) ? stored.order.map(String) : [],
        canvas: window.CorkopiaBuildCanvas?.sanitizeState?.(stored.canvas) || null
      };
    } catch (_) {
      return {
        project: '',
        enclosure: { width: null, depth: null, height: null },
        style: '',
        preference: '',
        budget: '',
        decisions: [],
        order: [],
        canvas: null
      };
    }
  };
  const advisorInput = () => {
    const build = readBuildContext();
    const acceptedFunction = (variantId) => [...build.decisions].reverse().find((decision) =>
      decision?.action === 'keep' && Number(decision.variantId) === Number(variantId)
    )?.functionId || '';
    const models = pieceItems().map(itemModel);
    return {
      buildBrief: {
        project: build.project,
        enclosure: build.enclosure,
        style: build.style,
        preference: build.preference,
        budget: build.budget
      },
      shopifyCart: {
        currency: cart.currency || settings.currency || 'USD',
        merchandiseSubtotalCents: pieceSubtotal(),
        itemCount: models.length,
        exactPieces: models.map((piece) => ({
          ...piece,
          functionId: acceptedFunction(piece.variantId)
        }))
      },
      currentShippingPlan: currentPlan ? {
        status: currentPlan.status,
        displayName: currentPlan.box?.name
          || (currentPlan.boxes?.length ? `${currentPlan.boxes.length} boxes` : ''),
        tierHandle: currentPlan.box?.handle || '',
        checkoutReady: currentPlan.checkoutReady === true,
        estimatedWeightOz: models.reduce((sum, piece) => sum + number(piece.weightOz), 0),
        source: 'existing_smart_box'
      } : null,
      decisionHistory: build.decisions,
      canvasState: build.canvas,
      pieceOrder: build.order,
      state: advisorState,
      cartAuthority: 'shopify',
      packingRecalculated: false
    };
  };
  const pieceFromElement = (element) => {
    const dimensions = [
      dimensionIn(element.dataset.lengthValue, element.dataset.lengthUnit),
      dimensionIn(element.dataset.widthValue, element.dataset.widthUnit),
      dimensionIn(element.dataset.heightValue, element.dataset.heightUnit)
    ];
    const explicitVolume = volumeCuIn(element.dataset.volumeValue, element.dataset.volumeUnit);
    const derivedVolume = dimensions.every(Number.isFinite) ? dimensions.reduce((total, value) => total * value, 1) * packingFactor(element.dataset.shapeClass, element.dataset.packingFactor) : null;
    return {
      button: element.matches?.('[data-cork-add]') ? element : null,
      variantId: number(element.dataset.variantId),
      title: element.dataset.productTitle || '',
      pieceId: element.dataset.pieceId || '',
      family: element.dataset.family || 'Natural cork',
      role: element.dataset.role || '',
      dimensionsText: element.dataset.dimensions || '',
      dimensions,
      weightOz: weightOz(element.dataset.weightValue, element.dataset.weightUnit),
      volumeCuIn: explicitVolume || derivedVolume,
      minimumBox: element.dataset.minimumBox || '',
      minimumSort: number(boxByHandle(element.dataset.minimumBox)?.sortOrder),
      orientation: element.dataset.orientation || '',
      clearanceIn: number(dimensionIn(element.dataset.protectiveClearance, element.dataset.protectiveClearanceUnit)),
      separateShipment: element.dataset.shippingBehavior === 'separate',
      manualReview: element.dataset.shippingBehavior === 'manual_review',
      shapeClass: normalizeShape(element.dataset.shapeClass),
      packingFactor: element.dataset.packingFactor,
      priceCents: number(element.dataset.priceCents),
      image: element.dataset.image || '',
      url: element.dataset.productUrl || ''
    };
  };
  const prefersReducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
  /* The box reacts to arrival, not to the click. Callers pass the moment the
     piece actually reaches the lid so the opening reads as caused by the piece
     rather than racing ahead of it. */
  const reactBox = ({ openAt = 0, landAt = 160 } = {}) => {
    const mount = $('[data-smart-box-mount]');
    const targets = [mount, review].filter(Boolean);
    if (!targets.length) return;
    const open = () => targets.forEach((target) => target.classList.add('is-receiving'));
    const land = () => targets.forEach((target) => {
      target.classList.remove('is-receiving');
      /* Restart the confirm keyframe when pieces are added back to back:
         re-adding a class that is already present is a no-op, which made the
         second of two quick adds silent. */
      target.classList.remove('is-confirmed');
      void target.offsetWidth;
      target.classList.add('is-confirmed');
    });
    const clear = () => targets.forEach((target) => target.classList.remove('is-confirmed'));
    if (openAt <= 0) open(); else window.setTimeout(open, openAt);
    window.setTimeout(land, landAt);
    window.setTimeout(clear, landAt + 560);
  };
  const animatePieceToBox = (piece) => {
    const target = $('[data-smart-box-mount]');
    if (!target) return;
    /* Cards and quick-view carry their own image. The product page has no card
       wrapper at all, so fall back to the main gallery image — without this the
       flight silently never runs on the primary add-to-box surface. */
    const sourceImage = piece.button
      ?.closest('[data-cork-product-card], [data-quick-view-dialog]')
      ?.querySelector('.cork-product-card__image--primary, [data-quick-view-image], img')
      || document.querySelector('.product-gallery__image');
    /* Aim at the box graphic, not the centre of the whole pill: the piece has
       to land in the box, not in the middle of a text label. */
    const graphic = target.querySelector('[data-smart-box-graphic]') || target;
    const from = sourceImage?.getBoundingClientRect?.();
    const mouth = graphic.getBoundingClientRect();
    /* Prefer the source element's already-decoded URL over the dataset one so
       the flyer paints on its first frame instead of after a fresh fetch. */
    const source = sourceImage?.currentSrc || sourceImage?.src || piece.image || '';
    /* Reduced motion, or nothing to fly: keep the confirmation, drop the travel. */
    if (prefersReducedMotion() || !from?.width || !mouth.width || !source) {
      reactBox({ openAt: 0, landAt: 160 });
      return;
    }

    /* The flyer starts as an exact copy of the source at the size and place it
       already occupies, so take-off is seamless: nothing resizes or jumps on
       the first frame. Everything after that is one composited transform. */
    const startWidth = from.width;
    const startHeight = from.height;
    const startX = from.left + from.width / 2;
    const startY = from.top + from.height / 2;
    const deltaX = mouth.left + mouth.width / 2 - startX;
    const deltaY = mouth.top + mouth.height * 0.42 - startY;
    const distance = Math.hypot(deltaX, deltaY);

    /* Land at roughly the width of the box mouth, and scale the duration with
       distance: a toss from a nearby card and a throw across the viewport
       should not take the same time. */
    const endScale = Math.min(0.55, Math.max(0.04, mouth.width * 0.82 / startWidth));
    const flight = Math.round(Math.min(760, Math.max(380, distance * 0.75)));
    const SETTLE = 200;
    /* A shallow bow, not a lob. Enough to read as travel through space rather
       than a slide along a rule; not enough to look like a catapult. */
    const apex = Math.min(72, Math.max(22, distance * 0.14));
    const tilt = deltaX < 0 ? 6 : -6;

    /* Sample the flight path itself rather than leaning on extreme easing
       curves per axis: y bows by `apex` at the midpoint and lands on deltaY,
       x runs straight. The single timing function below is what paces it, so
       the piece never hangs at the top of the arc and then drops. */
    const STEPS = 16;
    const path = [];
    for (let step = 0; step <= STEPS; step += 1) {
      const progress = step / STEPS;
      const bow = -apex * 4 * progress * (1 - progress);
      const eased = progress * progress * (3 - 2 * progress);
      const scale = 1 + (endScale - 1) * eased;
      const spin = tilt * Math.sin(Math.PI * progress);
      path.push({
        offset: progress,
        easing: 'linear',
        transform: `translate3d(${(deltaX * progress).toFixed(2)}px, ${(deltaY * progress + bow).toFixed(2)}px, 0) scale(${scale.toFixed(4)}) rotate(${spin.toFixed(2)}deg)`
      });
    }
    const landed = path[path.length - 1].transform;

    const flyer = document.createElement('span');
    flyer.className = 'c-smart-box-fly-piece';
    flyer.setAttribute('aria-hidden', 'true');
    const image = document.createElement('img');
    image.src = source;
    image.alt = '';
    image.decoding = 'async';
    image.draggable = false;
    /* Match how the source crops itself — cards cover a 4:5 frame, the product
       gallery contains — so the flyer is identical to what was on screen at
       take-off and the piece does not resize the instant it lifts. Neither fit
       paints a backdrop, so a transparent PNG stays transparent. */
    const fit = sourceImage ? getComputedStyle(sourceImage) : null;
    if (fit?.objectFit) image.style.objectFit = fit.objectFit;
    if (fit?.objectPosition) image.style.objectPosition = fit.objectPosition;
    flyer.append(image);
    Object.assign(flyer.style, {
      left: `${startX - startWidth / 2}px`,
      top: `${startY - startHeight / 2}px`,
      width: `${startWidth}px`,
      height: `${startHeight}px`
    });
    document.body.append(flyer);

    flyer.animate(path, { duration: flight, easing: 'cubic-bezier(0.4, 0.08, 0.42, 0.98)', fill: 'forwards' });

    /* Drop under the mount's stacking level just before arrival, while the
       piece already overlaps the pill, so the rest of the descent is occluded
       by the box front. The piece goes in; it does not sit on the lid and fade
       out in front of a shut box the way the old flight did. */
    window.setTimeout(() => flyer.classList.add('is-landing'), Math.max(0, flight - 60));

    window.setTimeout(() => {
      flyer.animate([
        { transform: landed },
        { transform: `translate3d(${deltaX.toFixed(2)}px, ${(deltaY + startHeight * endScale * 0.55).toFixed(2)}px, 0) scale(${(endScale * 0.7).toFixed(4)}) rotate(0deg)` }
      ], { duration: SETTLE, easing: 'cubic-bezier(0.4, 0, 0.7, 0.5)', fill: 'forwards' });
      flyer.animate([
        { offset: 0, opacity: 1 },
        { offset: 0.55, opacity: 1 },
        { offset: 1, opacity: 0 }
      ], { duration: SETTLE, fill: 'forwards' });
    }, flight);

    /* The lid finishes opening just before the piece arrives, and shuts behind it. */
    reactBox({ openAt: Math.max(0, flight - 200), landAt: flight + 70 });
    window.setTimeout(() => flyer.remove(), flight + SETTLE + 60);
  };
  const attributesForPlan = (plan) => {
    const primary = plan.box;
    return {
      corkopia_box_id: primary ? String(primary.id) : '',
      corkopia_box_name: primary ? primary.name : '',
      corkopia_shipping_tier: primary ? primary.handle : '',
      corkopia_shipping_price_cents: Number.isFinite(Number(plan.shippingCents)) ? String(plan.shippingCents) : '',
      corkopia_shipping_plan: plan.status,
      corkopia_shipping_box_count: String(plan.boxes?.length || 0),
      corkopia_shipping_box_ids: (plan.boxes || []).map((entry) => entry.box?.id).filter(Boolean).join(','),
      /* Which piece goes in which box. A multi-box plan is only correct as a
         grouping, so the grouping has to reach whoever packs it -- box ids alone
         leave the bench to guess, and a guess undoes the fit check. */
      corkopia_shipping_assignments: (plan.boxes || [])
        .map((entry) => `${entry.box?.handle || entry.box?.id || 'review'}:${(entry.items || []).map((item) => item.pieceId || item.variantId).join('+')}`)
        .join(';'),
      corkopia_shipping_review_required: plan.status === 'manual-review' ? 'true' : 'false',
      corkopia_inventory_engine_version: String(packingConfig.schemaVersion || '1.0.0')
    };
  };
  const syncPlanAttributes = async (plan) => {
    const attributes = attributesForPlan(plan);
    const changed = Object.entries(attributes).some(([key, value]) => String(cart.attributes?.[key] || '') !== value);
    if (!changed) return;
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes })
    });
    if (response.ok) cart = await response.json();
  };
  const recalculate = async (previousPlan = currentPlan, announce = false) => {
    currentPlan = engine.plan(boxes, pieceItems().map(itemModel), previousPlan?.box || null, manualBoxPreference);
    await syncPlanAttributes(currentPlan);
    if (!announce || currentPlan.status === 'empty') return render();
    if (currentPlan.status === 'single' && currentPlan.transition === 'selected') {
      showInlineMessage(`Your box fits in our ${currentPlan.box.name}.`);
      emit('automatic_box_selected', { shipping_box: currentPlan.box.handle });
    } else if (currentPlan.status === 'single' && currentPlan.transition === 'upgraded') {
      showInlineMessage(`Your selection grew, so we moved it to our ${currentPlan.box.name}. ${currentPlan.reason}`);
      if (!manualBoxPreference || String(manualBoxPreference.id) !== String(currentPlan.box.id)) manualBoxPreference = null;
      emit('automatic_box_upgraded', { shipping_box: currentPlan.box.handle, reason: currentPlan.limitingConstraint });
    } else if (currentPlan.status === 'single' && currentPlan.transition === 'downgraded') {
      showInlineMessage(`Your selection now fits best in our ${currentPlan.box.name}.`);
      emit('automatic_box_downgraded', { shipping_box: currentPlan.box.handle });
    } else if (currentPlan.status === 'multi-box' || currentPlan.status === 'separate') {
      showInlineMessage(`Your cork ships in ${currentPlan.boxes.length} boxes.`);
      emit('multi_box_plan_generated', { box_count: currentPlan.boxes.length });
    } else if (currentPlan.status === 'manual-review') {
      showInlineMessage('This selection needs a shipping review before checkout.');
      emit('manual_review_required');
    }
    render();
  };
  const enforceUniqueQuantity = async () => {
    const invalid = pieceItems().filter((item) => item.quantity !== 1);
    for (const item of invalid) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 1 })
      });
    }
    if (invalid.length) cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
  };
  const revalidateAvailability = async (announce = true) => {
    const unavailable = [];
    await Promise.all(pieceItems().map(async (item) => {
      try {
        const response = await fetch(`/variants/${item.variant_id}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (response.ok && !(await response.json()).available) unavailable.push(item);
      } catch (_) {
        // A network failure is not proof that a one-of-one piece sold.
      }
    }));
    for (const item of unavailable) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
      if (response.ok) cart = await response.json();
    }
    if (unavailable.length && announce) toast(`${unavailable.length === 1 ? 'A piece in your box is' : 'Some pieces in your box are'} no longer available. Your box was updated.`);
    return unavailable;
  };
  const getCart = async ({ validate = false } = {}) => {
    cart = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((response) => response.json());
    await enforceUniqueQuantity();
    if (validate) await revalidateAvailability();
    await recalculate(currentPlan, false);
    return cart;
  };
  const revalidatePiece = async (piece) => {
    const variantResponse = await fetch(`/variants/${piece.variantId}.js`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!variantResponse.ok || !(await variantResponse.json()).available) {
      document.dispatchEvent(new CustomEvent('corkopia:piece-unavailable', {
        detail: { variantId: piece.variantId, pieceId: piece.pieceId }
      }));
      throw new Error('This piece has just sold. Browse similar pieces to find another.');
    }
    return { ok: true, authority: 'shopify_current_validation' };
  };
  const addPieceRequest = async (piece, separate = false, options = {}) => {
    piece.button?.setAttribute('aria-busy', 'true');
    try {
      if (!options.revalidated) await revalidatePiece(piece);
      const properties = {
        _corkopia_inventory_type: 'individual_piece',
        _corkopia_piece_id: piece.pieceId,
        _corkopia_family: piece.family,
        _corkopia_role: piece.role || '',
        _corkopia_piece_weight_oz: String(piece.weightOz),
        _corkopia_minimum_box: piece.minimumBox,
        _corkopia_dimensions: piece.dimensionsText,
        _corkopia_max_length_in: String(piece.dimensions[0]),
        _corkopia_max_width_in: String(piece.dimensions[1]),
        _corkopia_max_height_in: String(piece.dimensions[2]),
        _corkopia_packing_volume_cu_in: String(piece.volumeCuIn),
        _corkopia_shape_class: piece.shapeClass,
        _corkopia_packing_factor: String(packingFactor(piece.shapeClass, piece.packingFactor)),
        _corkopia_orientation: piece.orientation,
        _corkopia_protective_clearance_in: String(piece.clearanceIn),
        _corkopia_separate_shipment: separate || piece.separateShipment ? 'true' : 'false',
        _corkopia_manual_review: piece.manualReview ? 'true' : 'false',
        _corkopia_inventory_engine_version: String(packingConfig.schemaVersion || '1.0.0')
      };
      const previousPlan = currentPlan;
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: piece.variantId, quantity: 1, properties }] })
      });
      if (!response.ok) {
        const body = await response.json();
        throw new Error(body.description || 'This piece could not be added to your box.');
      }
      cart = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((result) => result.json());
      localStorage.setItem('corkopia-cart-sync', String(Date.now()));
      emit(pieceItems().length === 1 ? 'smart_build_started' : 'piece_added', { piece_id: piece.pieceId || undefined });
      if (pieceItems().length === 1) emit('piece_added', { piece_id: piece.pieceId || undefined });
      await recalculate(previousPlan, true);
      window.CorkopiaProductExperience?.confirmAdd?.(piece.button, piece);
      animatePieceToBox(piece);
      analytics('product_add_to_box', {
        piece_id: piece.pieceId || '',
        variant_id: piece.variantId,
        family: piece.family || ''
      });
      toast(`${piece.pieceId || 'Piece'} added to your box.`);
      document.dispatchEvent(new CustomEvent('corkopia:piece-added', {
        detail: {
          variantId: piece.variantId,
          pieceId: piece.pieceId || '',
          family: piece.family || '',
          cart
        }
      }));
      return true;
    } catch (error) {
      toast(error.message);
      document.dispatchEvent(new CustomEvent('corkopia:piece-add-failed', {
        detail: {
          variantId: piece.variantId,
          pieceId: piece.pieceId || '',
          message: error.message
        }
      }));
      return false;
    } finally {
      piece.button?.removeAttribute('aria-busy');
    }
  };
  const askSeparateShipment = (piece) => {
    pendingPiece = piece;
    exceptionOpener = piece.button || document.activeElement;
    $('[data-exception-title]').textContent = 'This piece ships on its own.';
    $('[data-exception-copy]').textContent = 'It travels separately so the rest of your box stays safely packed.';
    $('[data-exception-actions]').innerHTML = '<button type="button" data-add-separate>Ship it separately</button><button type="button" data-exception-cancel>Remove this piece</button>';
    exception.showModal();
    syncOverlayLock();
    window.requestAnimationFrame(() => $('[data-add-separate]')?.focus());
  };
  const addPiece = async (piece, options = {}) => {
    if (!piece.variantId || !piece.weightOz || !piece.volumeCuIn || engine.sortedDimensions(piece.dimensions).length !== 3) {
      toast('This piece is still being measured and cannot be added yet.');
      return false;
    }
    await getCart();
    if (pieceItems().some((item) => Number(item.variant_id) === piece.variantId)) {
      toast('This piece is already in your box.');
      return false;
    }
    if (piece.separateShipment) {
      askSeparateShipment(piece);
      return false;
    }
    return addPieceRequest(piece, false, options);
  };
  const removePiece = async (key, trigger = null) => {
    const removedItem = cart.items.find((item) => item.key === key);
    const line = trigger?.closest('.smart-build-line');
    line?.classList.add('is-removing');
    trigger?.setAttribute('aria-busy', 'true');
    const previousPlan = currentPlan;
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    if (!response.ok) {
      line?.classList.remove('is-removing');
      trigger?.removeAttribute('aria-busy');
      toast('This piece could not be removed. Please try again.');
      return false;
    }
    cart = await response.json();
    if (removedItem) removedStack.push(removedItem);
    localStorage.setItem('corkopia-cart-sync', String(Date.now()));
    emit('piece_removed');
    analytics('smart_box_item_removed', { line_key: key });
    await recalculate(previousPlan, true);
    toast('Piece removed from your box.');
    document.dispatchEvent(new CustomEvent('corkopia:piece-removed', {
      detail: { key, cart }
    }));
    const undo = $('[data-smart-box-undo]');
    if (undo) undo.disabled = removedStack.length === 0;
    return true;
  };
  const undoLastRemove = async () => {
    const item = removedStack.pop();
    if (!item) return false;
    const availability = await fetch(`/variants/${item.variant_id}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!availability.ok || !(await availability.json()).available) {
      toast('That piece is no longer available, so it cannot be restored.');
      return false;
    }
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: item.variant_id, quantity: 1, properties: item.properties || {} }] })
    });
    if (!response.ok) {
      removedStack.push(item);
      toast('That piece could not be restored. Please try again.');
      return false;
    }
    cart = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((result) => result.json());
    localStorage.setItem('corkopia-cart-sync', String(Date.now()));
    await recalculate(currentPlan, true);
    const undo = $('[data-smart-box-undo]');
    if (undo) undo.disabled = removedStack.length === 0;
    toast('Piece restored to your box.');
    return true;
  };
  const clearExactPieces = async () => {
    const items = [...pieceItems()];
    if (!items.length || !window.confirm('Remove every exact piece from your box? Seller\u2019s Choice boxes and other cart items stay.')) return false;
    for (const item of items) {
      const removed = await removePiece(item.key);
      if (!removed) return false;
    }
    toast('Exact pieces removed. Other items in your cart were not changed.');
    return true;
  };
  const orchestrationSource = (trigger) => {
    if (trigger?.closest?.('[data-build-canvas-inspector], [data-build-canvas-piece]')) return 'visual_build_canvas';
    if (trigger?.closest?.('[data-build-studio]')) return 'build_studio';
    if (trigger?.closest?.('[data-smart-build-review]')) return 'smart_box';
    return 'storefront';
  };
  const announceOrchestrationStep = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent('corkopia:orchestrator-step-requested', {
      detail: { name, ...detail }
    }));
    return { ok: true, scheduled: true };
  };
  const orchestratedAddFromElement = async (element, separateShipmentConfirmed = false) => {
    const piece = pieceFromElement(element);
    const orchestrator = window.CorkopiaOrchestrator;
    const recommendationId = element?.dataset?.recommendationId;
    if (!orchestratorApi || !orchestrator || !element?.closest?.('[data-build-studio]')) {
      return addPiece(piece);
    }
    if (piece.separateShipment && !separateShipmentConfirmed) {
      pendingOrchestrationElement = element;
      askSeparateShipment(piece);
      return false;
    }
    const command = orchestratorApi.createCommand(
      orchestratorApi.COMMANDS.ADD_PRODUCT_TO_CART,
      {
        recommendationId: recommendationId || `build-${piece.variantId}`,
        requestId: element.dataset.requestId || '',
        variantId: piece.variantId,
        pieceId: piece.pieceId,
        family: piece.family,
        surface: 'build_studio'
      },
      {
        sourceSystem: 'build_studio',
        actorType: 'anonymous_customer',
        causationId: recommendationId || `build-${piece.variantId}`
      }
    );
    const result = await orchestrator.execute(command, {
      revalidateEligibility: () => revalidatePiece(piece),
      stageAcceptanceUi: () => {
        element.setAttribute('aria-busy', 'true');
        return { ok: true };
      },
      restoreAcceptanceUi: () => {
        element.removeAttribute('aria-busy');
        return { ok: true };
      },
      cartAdd: async () => {
        const added = piece.separateShipment
          ? await addPieceRequest(piece, true, { revalidated: true })
          : await addPiece(piece, { revalidated: true });
        if (!added) return { ok: false, code: 'SHOPIFY_CART_ADD_FAILED' };
        return { ok: true, authority: 'shopify', variantId: piece.variantId };
      },
      updateBuildDnaAccepted: () => announceOrchestrationStep('BUILD_DNA_UPDATED', { variantId: piece.variantId }),
      syncCanvas: () => announceOrchestrationStep('CANVAS_SYNCHRONIZED', { variantId: piece.variantId }),
      recalculateBuildHealth: () => announceOrchestrationStep('BUILD_HEALTH_RECALCULATED'),
      updateBuildTimeline: () => announceOrchestrationStep('BUILD_TIMELINE_UPDATED'),
      refreshSmartBoxAdvisor: () => announceOrchestrationStep('SMART_BOX_ADVISOR_REFRESHED'),
      refreshNextBestPiece: () => announceOrchestrationStep('NEXT_BEST_PIECE_REFRESHED'),
      emitAnalytics: () => ({ ok: true, provider: null })
    });
    return result.currentState === 'SUCCEEDED'
      && result.outputs.shopify_cart_add?.ok === true;
  };
  const orchestratedRemoveLine = async (key, trigger = null) => {
    const orchestrator = window.CorkopiaOrchestrator;
    if (!orchestratorApi || !orchestrator) return removePiece(key, trigger);
    const command = orchestratorApi.createCommand(
      orchestratorApi.COMMANDS.REMOVE_PRODUCT_FROM_CART,
      {
        cartLineKey: key,
        variantId: trigger?.dataset?.variantId || '',
        pieceId: trigger?.dataset?.pieceId || '',
        surface: orchestrationSource(trigger)
      },
      {
        sourceSystem: orchestrationSource(trigger),
        actorType: 'anonymous_customer',
        causationId: key
      }
    );
    const result = await orchestrator.execute(command, {
      cartRemove: async () => {
        const removed = await removePiece(key, trigger);
        if (!removed) return { ok: false, code: 'SHOPIFY_CART_REMOVE_FAILED' };
        return { ok: true, authority: 'shopify', cartLineKey: key };
      },
      removeCanvasPlacement: () => announceOrchestrationStep('CANVAS_SYNCHRONIZED', { cartLineKey: key }),
      updateBuildDnaRemoved: () => announceOrchestrationStep('BUILD_DNA_UPDATED', { cartLineKey: key }),
      recalculateBuildHealth: () => announceOrchestrationStep('BUILD_HEALTH_RECALCULATED'),
      updateBuildTimeline: () => announceOrchestrationStep('BUILD_TIMELINE_UPDATED'),
      refreshAdvisors: () => announceOrchestrationStep('ADVISORS_REFRESHED'),
      emitAnalytics: () => ({ ok: true, provider: null })
    });
    return result.currentState === 'SUCCEEDED'
      && result.outputs.shopify_cart_remove?.ok === true;
  };
  const planDescription = (plan) => {
    if (plan.status === 'empty') return 'Choose any cork piece. We’ll select the shipping box for you.';
    if (plan.status === 'single') return `${plan.box.name} · Everything fits`;
    if (plan.status === 'multi-box') return `Ships in ${plan.boxes.length} boxes · Your selection is more than one box holds safely.`;
    if (plan.status === 'separate') return `Ships in ${plan.boxes.length} boxes · One piece needs a box of its own.`;
    return 'Shipping review needed · We’ll confirm your shipping before checkout opens.';
  };
  const statusContent = (plan) => {
    if (plan.status === 'single') return ['Everything fits', plan.box.name, 'safe'];
    if (plan.status === 'multi-box') return [`Ships in ${plan.boxes.length} boxes`, 'Your selection needs more than one box.', 'multi'];
    if (plan.status === 'separate') return [`Ships in ${plan.boxes.length} boxes`, 'One piece needs a box of its own.', 'multi'];
    return ['Shipping review needed', 'Request a shipping review and we’ll confirm the details.', 'review'];
  };
  const displayLabel = (value = '') => String(value || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase());
  const stars = (value, maximum = 5) => {
    const count = Math.min(maximum, Math.max(0, Number(value) || 0));
    return `<span class="smart-box-health__stars" aria-hidden="true">${'★'.repeat(count)}${'☆'.repeat(maximum - count)}</span>
      <span class="c-visually-hidden">${count} of ${maximum} evidence stars</span>`;
  };
  const dnaValue = (value, empty = 'Not available') => {
    if (Array.isArray(value)) return value.length ? value.map(displayLabel).join(', ') : empty;
    return value || empty;
  };
  const renderAdvisor = () => {
    const region = $('[data-smart-box-advisor]');
    if (!region || !smartAdvisor?.run) return;
    advisorResponse = smartAdvisor.run(advisorInput());
    advisorState = smartAdvisor.writeState?.(window.localStorage, advisorResponse.state || advisorState)
      || advisorResponse.state
      || advisorState;
    const recommendations = advisorResponse.recommendations || [];
    const health = advisorResponse.build_health || {};
    const timeline = advisorResponse.build_timeline || [];
    const dna = advisorResponse.build_dna || {};
    const buildUrl = region.dataset.buildStudioUrl || '/pages/build-studio';
    const fingerprint = JSON.stringify({
      recommendations: recommendations.map((entry) => entry.recommendation_id),
      health: Object.fromEntries(Object.entries(health).map(([id, entry]) => [id, entry.stars])),
      timeline: timeline.map((entry) => `${entry.id}:${entry.status}`)
    });
    const changed = advisorFingerprint && advisorFingerprint !== fingerprint;
    advisorFingerprint = fingerprint;
    region.hidden = false;
    region.dataset.advisorOutcome = advisorResponse.outcome;

    const context = [];
    if (dna.animal) context.push(['Project', displayLabel(dna.animal)]);
    if (dna.enclosure?.width) {
      context.push(['Enclosure', `${dna.enclosure.width} × ${dna.enclosure.depth} × ${dna.enclosure.height} in`]);
    }
    if (dna.style) context.push(['Style', displayLabel(dna.style)]);
    if (dna.preference) context.push(['Preference', displayLabel(dna.preference)]);
    if (dna.budget?.id) {
      context.push(['Budget', dna.budget.id === 'unlimited' ? 'Unlimited' : `Around $${dna.budget.id}`]);
    }
    context.push(['Pieces', String(dna.accepted_pieces?.length || 0)]);
    if (dna.estimated_shipping_tier?.display_name) {
      context.push(['Shipping estimate', dna.estimated_shipping_tier.display_name]);
    }
    if (dna.estimated_weight) {
      context.push(['Observed weight', `${Number(dna.estimated_weight.value).toFixed(1)} oz`]);
    }
    $('[data-smart-box-context]').innerHTML = context.map(([label, value]) =>
      `<span><small>${escapeHtml(label)}</small><strong>${escapeHtml(value)}</strong></span>`
    ).join('');

    $('[data-smart-box-recommendations]').innerHTML = recommendations.length
      ? recommendations.map((entry) => {
          const isDirection = entry.type === 'next_function' || entry.type === 'family_focus';
          return `<article
            class="smart-box-advisor-card"
            data-smart-box-card
            data-card-category="${escapeHtml(entry.category)}"
          >
            <span class="smart-box-advisor-card__icon" data-icon="${escapeHtml(entry.icon)}" aria-hidden="true"></span>
            <div>
              <p>${escapeHtml(entry.category)}</p>
              <h4>${escapeHtml(entry.title)}</h4>
              <p>${escapeHtml(entry.summary)}</p>
              ${entry.limitations?.length ? `<small>${escapeHtml(entry.limitations[0])}</small>` : ''}
              <div class="smart-box-advisor-card__actions">
                ${entry.proposed_actions?.some((action) => action.type === 'OPEN_BUILD_STUDIO')
                  ? `<a href="${escapeHtml(buildUrl)}">${isDirection ? 'Explore this direction' : 'Open Build Studio'}</a>`
                  : ''}
                <button
                  type="button"
                  data-smart-box-advisor-action="accept"
                  data-recommendation-id="${escapeHtml(entry.recommendation_id)}"
                >${isDirection ? 'Save direction' : 'Got it'}</button>
                <button
                  type="button"
                  data-smart-box-advisor-action="dismiss"
                  data-recommendation-id="${escapeHtml(entry.recommendation_id)}"
                >Dismiss</button>
              </div>
            </div>
          </article>`;
        }).join('')
      : '<p class="smart-box-advisor__empty">No new guidance right now. We’ll check again when your box or your brief changes.</p>';

    $('[data-smart-box-health]').innerHTML = Object.entries(health).map(([, entry]) => `
      <article>
        <div>
          <strong>${escapeHtml(entry.label)}</strong>
          <span>${stars(entry.stars, entry.maximumStars)}</span>
        </div>
        <p>${escapeHtml(entry.status)}</p>
        <small>${escapeHtml(entry.explanation)}</small>
        <small>${escapeHtml(entry.evidence)}</small>
      </article>
    `).join('');

    $('[data-smart-box-timeline]').innerHTML = timeline.map((entry) => `
      <li data-timeline-status="${escapeHtml(entry.status)}">
        <span aria-hidden="true"></span>
        <div>
          <strong>${escapeHtml(entry.label)}</strong>
          <small>${escapeHtml(displayLabel(entry.status))}</small>
        </div>
      </li>
    `).join('');

    const dnaRows = [
      ['Animal / project', displayLabel(dna.animal)],
      ['Enclosure', dna.enclosure?.width ? `${dna.enclosure.width} × ${dna.enclosure.depth} × ${dna.enclosure.height} in` : 'Not selected'],
      ['Style', displayLabel(dna.style)],
      ['Budget', dna.budget?.id === 'unlimited' ? 'Unlimited' : dna.budget?.id ? `Around $${dna.budget.id}` : 'Not selected'],
      ['Primary functions', dnaValue(dna.primary_functions, 'Complete the Build Studio style step')],
      ['Chosen functions', dnaValue(dna.chosen_functions, 'None represented yet')],
      ['Chosen layers', dnaValue(dna.chosen_layers, 'None represented yet')],
      ['Canvas placements', String(dna.placements?.length || 0)],
      ['Chosen families', dnaValue(dna.chosen_families, 'None selected yet')],
      ['Estimated shipping tier', dna.estimated_shipping_tier?.display_name || 'Calculated once you add a piece'],
      ['Estimated weight', dna.estimated_weight ? `${Number(dna.estimated_weight.value).toFixed(1)} oz` : 'Not available'],
      ['Current recommendations', String(dna.current_recommendations?.length || 0)],
      ['Accepted pieces', String(dna.accepted_pieces?.length || 0)],
      ['Rejected pieces', String(dna.rejected_pieces?.length || 0)],
      ['Replacement history', String(dna.replacement_history?.length || 0)],
      ['Saved builds', 'Not available yet'],
      ['Shared builds', 'Not available yet']
    ];
    $('[data-smart-box-dna]').innerHTML = dnaRows.map(([label, value]) =>
      `<div><dt>${escapeHtml(label)}</dt><dd>${escapeHtml(value || 'Not available')}</dd></div>`
    ).join('');
    $('[data-smart-box-limitations]').textContent = (advisorResponse.explanation?.limitations || []).join(' ');
    $('[data-smart-box-advisor-state]').textContent = advisorResponse.outcome === 'recommended'
      ? `${recommendations.length} current ${recommendations.length === 1 ? 'observation' : 'observations'}`
      : 'Watching for the next useful change';
    const mountGuidance = $('[data-smart-box-mount-guidance]');
    if (mountGuidance) {
      mountGuidance.textContent = recommendations[0]?.title || 'Build guidance';
    }
    if (changed) {
      region.classList.remove('is-updating');
      window.requestAnimationFrame(() => region.classList.add('is-updating'));
      window.setTimeout(() => region.classList.remove('is-updating'), 520);
      const status = $('[data-smart-box-advisor-status]');
      if (status) status.textContent = recommendations[0]
        ? `Guidance updated. ${recommendations[0].title}.`
        : 'Guidance is up to date.';
    }
    if (review) {
      review.smartBoxBuildDNA = dna;
      review.smartBoxAdvisorResponse = advisorResponse;
    }
    document.dispatchEvent(new CustomEvent('corkopia:smart-box-advisor-result', {
      detail: {
        requestId: advisorResponse.request_id,
        outcome: advisorResponse.outcome,
        recommendationIds: recommendations.map((entry) => entry.recommendation_id)
      }
    }));
  };
  const scheduleAdvisorRender = () => {
    clearTimeout(advisorRenderTimer);
    advisorRenderTimer = window.setTimeout(renderAdvisor, 20);
  };
  const render = () => {
    const items = pieceItems();
    const subtotal = pieceSubtotal();
    const active = items.length > 0;
    const changed = renderedPieceCount !== items.length || renderedSubtotal !== subtotal;
    if (renderedPieceCount >= 0 && changed) {
      [review, $('[data-smart-box-mount]')].filter(Boolean).forEach((element) => {
        element.classList.remove('is-value-updating');
        window.requestAnimationFrame(() => element.classList.add('is-value-updating'));
        window.setTimeout(() => element.classList.remove('is-value-updating'), 520);
      });
    }
    renderedPieceCount = items.length;
    renderedSubtotal = subtotal;
    const realCartSummary = cartSummary?.render(document, cart, settings.currency) || {
      itemCount: number(cart.item_count),
      subtotalCents: number(cart.total_price)
    };
    renderHabitatPlan();
    document.dispatchEvent(new CustomEvent('corkopia:cart-updated', { detail: realCartSummary }));
    $$('[data-build-compact-count]').forEach((element) => { element.textContent = `${items.length} ${items.length === 1 ? 'piece' : 'pieces'}`; });
    $$('[data-build-compact-total], [data-build-mobile-total]').forEach((element) => { element.textContent = money(subtotal); });
    $$('[data-build-mobile-count]').forEach((element) => { element.textContent = `${items.length} ${items.length === 1 ? 'Piece' : 'Pieces'}`; });
    $('[data-build-empty]').hidden = active;
    $('[data-build-active]').hidden = !active;
    $$('[data-build-count]').forEach((element) => { element.textContent = String(items.length); });
    $$('[data-build-subtotal]').forEach((element) => { element.textContent = money(subtotal); });
    $$('[data-build-weight]').forEach((element) => { element.textContent = displayWeight(pieceWeightOz()); });
    $$('[data-simple-box-count]').forEach((element) => { element.textContent = String(items.length); });
    $$('[data-simple-box-weight]').forEach((element) => { element.textContent = displayWeight(pieceWeightOz()); });
    $$('[data-simple-box-subtotal]').forEach((element) => { element.textContent = money(subtotal); });
    $$('[data-review-piece-label]').forEach((element) => { element.textContent = items.length === 1 ? 'piece' : 'pieces'; });
    const mount = $('[data-smart-box-mount]');
    if (mount) mount.dataset.boxState = active ? 'filled' : 'empty';
    if (review) review.dataset.boxState = active ? 'filled' : 'empty';
    const reviewEmpty = $('[data-review-empty]');
    const reviewActive = $('[data-review-active]');
    if (reviewEmpty) reviewEmpty.hidden = active;
    if (reviewActive) reviewActive.hidden = !active;
    const [status, detail, state] = statusContent(currentPlan);
    $('[data-build-status]').textContent = status;
    $('[data-build-status-detail]').textContent = detail;
    $('[data-build-status-box]').dataset.state = state;
    $('[data-build-box]').textContent = currentPlan.box?.name || (currentPlan.boxes?.length ? `${currentPlan.boxes.length} boxes` : 'Confirmed at review');
    $('[data-build-shipping]').textContent = shippingMoney(currentPlan.shippingCents);
    $('[data-build-capacity-label]').textContent = currentPlan.capacityLabel || 'Room available';
    const bar = $('i', $('[data-build-capacity-track]'));
    bar.style.width = currentPlan.status === 'single' ? `${Math.min(100, Math.max(12, number(currentPlan.utilization) * 100))}%` : currentPlan.status === 'manual-review' ? '100%' : '88%';
    const utilizationPercent = currentPlan.status === 'single'
      ? Math.min(100, Math.max(0, Math.round(number(currentPlan.utilization) * 100)))
      : currentPlan.status === 'empty' ? 0 : 100;
    const currentBoxIndex = currentPlan.box ? boxes.findIndex((box) => String(box.id) === String(currentPlan.box.id)) : -1;
    const nextBox = currentBoxIndex >= 0 ? boxes[currentBoxIndex + 1] : boxes[0];
    const remainingWeightOz = currentPlan.box
      ? Math.max(0, number(currentPlan.box.maxWeightOz) - pieceWeightOz())
      : 0;
    const nextUpgradeText = currentPlan.box
      ? nextBox
        ? `${nextBox.name} · ${(remainingWeightOz / 16).toFixed(1)} lb to go`
        : 'Largest size available'
      : '—';
    $$('[data-simple-box-space]').forEach((element) => { element.textContent = active ? `${utilizationPercent}% full` : 'No pieces yet'; });
    $$('[data-simple-box-current]').forEach((element) => { element.textContent = currentPlan.box?.name || 'Selected automatically'; });
    $$('[data-simple-box-next]').forEach((element) => { element.textContent = nextUpgradeText; });
    $$('[data-simple-box-fill], [data-review-capacity-fill]').forEach((element) => { element.style.width = `${utilizationPercent}%`; });
    $$('[data-review-space]').forEach((element) => { element.textContent = `${utilizationPercent}% full`; });
    $$('[data-review-box-dimensions]').forEach((element) => {
      element.textContent = currentPlan.box
        ? `${currentPlan.box.length} × ${currentPlan.box.width} × ${currentPlan.box.height}`
        : 'Selected automatically';
    });
    $$('[data-review-next-upgrade]').forEach((element) => { element.textContent = nextUpgradeText; });
    $$('[data-box-nearly-full]').forEach((element) => { element.hidden = !(active && currentPlan.status === 'single' && number(currentPlan.utilization) >= .78); });
    $$('.simple-box-preview').forEach((element) => element.classList.toggle('is-filled', active));
    const message = $('[data-build-message]');
    message.hidden = !inlineMessage;
    message.textContent = inlineMessage;
    $('[data-request-shipping-review]').hidden = currentPlan.status !== 'manual-review';
    $('[data-review-notice]').textContent = planDescription(currentPlan);
    $('[data-review-notice]').dataset.state = state;
    $('[data-review-shipping-plan]').textContent = planDescription(currentPlan);
    $('[data-review-box]').textContent = currentPlan.box?.name || (currentPlan.boxes?.length ? `${currentPlan.boxes.length} boxes` : 'Confirmed at review');
    $('[data-review-subtotal]').textContent = money(subtotal);
    $('[data-review-shipping]').textContent = shippingMoney(currentPlan.shippingCents);
    $('[data-build-checkout]').disabled = !currentPlan.checkoutReady || !items.length;
    $('[data-build-items]').innerHTML = items.map((item, index) => {
      const model = itemModel(item);
      return `<article class="smart-build-line" style="--smart-line-index:${index}">
        <img src="${escapeHtml(model.image)}" alt="">
        <div><h3>${escapeHtml(model.pieceId || model.title || 'Exact cork piece')}</h3><p>${escapeHtml(model.family)}</p>${model.role ? `<small>${escapeHtml(model.role)}</small>` : ''}<small>${escapeHtml(model.dimensionsText)}</small></div>
        <strong>${money(model.priceCents)}</strong>
        <div class="smart-build-line__actions">
          ${model.url ? `<a href="${escapeHtml(model.url)}">View details</a><a href="${escapeHtml(model.url)}" aria-label="Find a replacement for ${escapeHtml(model.pieceId || 'this piece')}">Replace</a>` : ''}
          <button type="button" data-remove-key="${escapeHtml(item.key)}" aria-label="Remove ${escapeHtml(model.pieceId || 'this piece')}">Remove</button>
        </div>
      </article>`;
    }).join('') || '<p class="smart-build-no-items">Your box is empty.</p>';
    const buildContext = readBuildContext();
    const budget = Number(buildContext.budget);
    const budgetLabel = $('[data-build-budget-label]');
    const budgetBar = $('[data-build-budget-bar]');
    if (budgetLabel) budgetLabel.textContent = budget > 0 ? `${money(subtotal)} of ${money(budget * 100)}` : 'No budget selected';
    if (budgetBar) budgetBar.style.width = budget > 0 ? `${Math.min(100, Math.round((subtotal / (budget * 100)) * 100))}%` : '0%';
    const fit = $('[data-smart-box-fit]');
    if (fit) fit.textContent = [buildContext.enclosure.width, buildContext.enclosure.depth, buildContext.enclosure.height].every(Number.isFinite) ? 'Customer dimensions active' : 'Not selected';
    const substitution = $('[data-smart-box-substitution]');
    if (substitution) substitution.textContent = habitatPlan ? 'Plan suggestions require confirmation' : 'Exact pieces only';
    $$('[data-cork-add]').forEach((button) => {
      const inCart = items.some((item) => Number(item.variant_id) === Number(button.dataset.variantId));
      if (!button.dataset.defaultLabel && button.textContent.trim()) button.dataset.defaultLabel = button.textContent.trim();
      if (inCart) {
        button.disabled = true;
        button.dataset.added = 'true';
        button.textContent = 'Added ✓';
      } else if (button.dataset.added === 'true') {
        button.disabled = false;
        delete button.dataset.added;
        button.textContent = button.dataset.defaultLabel || 'Add to Box';
      }
    });
    $$('[data-product-box-current]').forEach((summary) => {
      summary.hidden = !active;
      if (!active) return;
      $('[data-product-box-name]', summary).textContent = currentPlan.box?.name || currentPlan.capacityLabel;
      $('[data-product-box-used]', summary).textContent = `${items.length} ${items.length === 1 ? 'piece' : 'pieces'}`;
      $('[data-product-box-remaining]', summary).textContent = currentPlan.capacityLabel;
    });
    $$('[data-box-impact]').forEach((element) => {
      const piece = pieceFromElement(element);
      const previewPlan = engine.plan(boxes, [...items.map(itemModel), piece], currentPlan.box);
      element.textContent = previewPlan.status === 'single'
        ? `We’ll fit this piece safely in our ${previewPlan.box.name}.`
        : previewPlan.status === 'multi-box' || previewPlan.status === 'separate'
          ? 'This piece will create an additional shipment.'
          : 'This piece may need a custom shipping review.';
    });
    scheduleAdvisorRender();
  };
  const openReview = (trigger) => {
    render();
    reviewOpener = trigger || document.activeElement;
    const wasOpen = review.open;
    if (!wasOpen) {
      review.showModal();
      syncOverlayLock();
      window.requestAnimationFrame(() => $('[data-review-build-close]', review)?.focus());
      analytics('smart_box_expanded', { piece_count: pieceItems().length });
    }
    emit('review_build_opened');
  };
  const checkout = async () => {
    const unavailable = await revalidateAvailability();
    await recalculate(currentPlan, false);
    if (unavailable.length) return render();
    if (!currentPlan.checkoutReady) return toast('A valid shipping plan is required before checkout.');
    checkoutStarted = true;
    emit('checkout_started', { shipping_plan: currentPlan.status, box_count: currentPlan.boxes.length });
    analytics('smart_box_checkout_started', { piece_count: pieceItems().length, shipping_plan: currentPlan.status });
    window.location.href = '/checkout';
  };
  const requestReview = async () => {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { corkopia_shipping_review_requested: 'true' } })
    });
    if (response.ok) {
      cart = await response.json();
      toast('Your build is saved and the shipping review request is noted.');
    }
  };

  document.addEventListener('click', async (event) => {
    const advisorAction = event.target.closest('[data-smart-box-advisor-action]');
    if (advisorAction && advisorResponse) {
      const result = smartAdvisor?.actionFor?.(
        advisorResponse,
        advisorState,
        advisorAction.dataset.smartBoxAdvisorAction,
        advisorAction.dataset.recommendationId
      );
      if (result?.accepted) {
        advisorState = smartAdvisor.writeState?.(window.localStorage, result.state) || result.state;
        toast(result.code === 'RECOMMENDATION_ACCEPTED'
          ? 'Direction saved. We’ll keep an eye on your box as it changes.'
          : 'Suggestion dismissed. We’ll check again after your box changes.');
        renderAdvisor();
      }
      return;
    }
    const add = event.target.closest('[data-cork-add]');
    if (add) { event.preventDefault(); await orchestratedAddFromElement(add); return; }
    const reviewTrigger = event.target.closest('[data-review-build-open], [data-cork-box-open]');
    if (reviewTrigger) { event.preventDefault(); openReview(reviewTrigger); return; }
    if (event.target.closest('[data-review-build-close]')) { if (review.open) review.close(); return; }
    const remove = event.target.closest('[data-remove-key]');
    if (remove) { await orchestratedRemoveLine(remove.dataset.removeKey, remove); return; }
    if (event.target.closest('[data-build-checkout]')) { await checkout(); return; }
    if (event.target.closest('[data-smart-box-undo]')) { await undoLastRemove(); return; }
    if (event.target.closest('[data-smart-box-clear]')) { await clearExactPieces(); return; }
    if (event.target.closest('[data-box-upgrade]')) {
      const currentIndex = currentPlan.box ? boxes.findIndex((box) => String(box.id) === String(currentPlan.box.id)) : -1;
      const candidate = currentIndex >= 0 ? boxes[currentIndex + 1] : null;
      if (!candidate) { toast('This build is already using the largest configured box.'); return; }
      manualBoxPreference = candidate;
      $$('.simple-box-preview, [data-smart-box-mount], [data-box-state]').forEach((element) => element.classList.add('is-upgrading'));
      await recalculate(currentPlan, false);
      showInlineMessage('Your box upgraded for a better fit.');
      toast('Your box upgraded for a better fit.');
      window.setTimeout(() => $$('.is-upgrading').forEach((element) => element.classList.remove('is-upgrading')), 700);
      return;
    }
    if (event.target.closest('[data-focus-build-items]')) {
      $('[data-build-items]')?.scrollIntoView({ behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      $('[data-build-items] button')?.focus();
      return;
    }
    if (event.target.closest('[data-smart-box-save]')) {
      localStorage.setItem('corkopia-smart-box-local-snapshot-v1', JSON.stringify({
        savedAt: new Date().toISOString(),
        pieceIds: pieceItems().map((item) => item.properties?._corkopia_piece_id).filter(Boolean),
        buildId: cart.attributes?.corkopia_build_id || '',
        note: 'Reference only; Shopify remains cart authority.'
      }));
      toast('A reference to this box was saved on this device.');
      return;
    }
    if (event.target.closest('[data-request-shipping-review]')) { await requestReview(); return; }
    if (event.target.closest('[data-add-separate]') && pendingPiece) {
      exception.close();
      const piece = pendingPiece;
      const orchestrationElement = pendingOrchestrationElement;
      pendingPiece = null;
      pendingOrchestrationElement = null;
      if (orchestrationElement) {
        await orchestratedAddFromElement(orchestrationElement, true);
      } else {
        await addPieceRequest(piece, true);
      }
      return;
    }
    if (event.target.closest('[data-exception-cancel]')) {
      pendingPiece = null;
      pendingOrchestrationElement = null;
      exception.close();
    }
  });
  document.addEventListener('DOMContentLoaded', async () => {
    const mount = $('[data-smart-build-summary-mount]');
    if (mount) mount.append($('#SmartBuildSummary'));
    await getCart({ validate: true });
  });
  review?.addEventListener('close', () => {
    syncOverlayLock();
    analytics('smart_box_collapsed', { piece_count: pieceItems().length });
    if (reviewOpener?.isConnected) reviewOpener.focus();
    reviewOpener = null;
  });
  exception?.addEventListener('close', () => {
    syncOverlayLock();
    if (exceptionOpener?.isConnected) exceptionOpener.focus();
    exceptionOpener = null;
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) getCart({ validate: true }); });
  document.addEventListener('corkopia:build-context-updated', scheduleAdvisorRender);
  document.addEventListener('corkopia:habitat-build-accepted', (event) => {
    if (event.detail?.cartMutation !== false || event.detail?.customerConfirmationRequired !== true) return;
    habitatPlan = readHabitatPlan();
    renderHabitatPlan();
    openReview(document.activeElement);
    toast('Measured habitat plan prepared. Confirm exact pieces through Shopify.');
  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-habitat-box-plan-dismiss]')) return;
    habitatPlan = null;
    sessionStorage.removeItem('corkopia-habitat-smart-box-handoff-v1');
    renderHabitatPlan();
    toast('Habitat plan dismissed. Shopify cart unchanged.');
  });
  document.addEventListener('corkopia:orchestrator-step-requested', (event) => {
    if (['SMART_BOX_ADVISOR_REFRESHED', 'ADVISORS_REFRESHED', 'BUILD_DNA_UPDATED', 'CANVAS_SYNCHRONIZED'].includes(event.detail?.name)) {
      scheduleAdvisorRender();
    }
  });
  window.addEventListener('storage', (event) => { if (event.key === 'corkopia-cart-sync') getCart({ validate: true }); });
  window.addEventListener('pagehide', () => {
    if (pieceItems().length && !checkoutStarted) emit('build_abandoned');
  });

  window.CorkopiaMyBox = Object.freeze({
    addFromElement(element) {
      return orchestratedAddFromElement(element);
    },
    removeLine(key, trigger = null) {
      return orchestratedRemoveLine(key, trigger);
    },
    refresh(options = {}) {
      return getCart(options);
    },
    advisor() {
      return advisorResponse;
    },
    undoLastRemove,
    clearExactPieces,
    open(trigger = null) {
      openReview(trigger || document.activeElement);
    }
  });
})();
